export default __webpack_public_path__ + "static/wizard-purple-512-e56903f86aa99cbde1cc6a2d5fff66f1.png";